export const ACCOUNT_ORGANIZATIONS_LIST_URL = 'account/{accountId}/account-organization/list';
export const CREATE_ACCOUNT_ORGANIZATION_URL = 'account/{accountId}/account-organization';
